import type { ValidProperties } from '@wmgone/analytics';
import { createAnalyticsModule } from '@wmgone/analytics';
import { useCallback } from 'react';

export type AnalyticsAppType =
  | 'Artist Roster'
  | 'Label Performance'
  | 'Global Search'
  | 'Link Farm';

// Initialize the Analytics module that will be used to track events in the
// various Container applications.
const analytics = createAnalyticsModule();

// NOTE: Specifically not passing in an application name here. It will be set
//       when using the useAnalytics hook (e.g. - useAnalytics('Artist Roster')).
analytics.init('');

/**
 * Custom hook that exposes what we need for the Container analytics.
 *
 * @param appType - The type of application that is using the analytics module.
 * @returns An object containing two functions to track events and flush analytics.
 */
function useAnalytics(appType: AnalyticsAppType) {
  const trackEvent = useCallback(
    (eventName: string, eventProperties?: ValidProperties) => {
      const allProperties: ValidProperties = {
        ...eventProperties,
        application: appType,
      };

      analytics.trackEvent(eventName, allProperties);
    },
    [appType],
  );

  return {
    trackEvent,
    flushAnalytics: analytics.flushAnalytics,
  };
}

export { useAnalytics };
